/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import axios, { AxiosResponse } from 'axios';
import { getConfig } from 'id-utils/config';
import { baseRequest, axiosDefaults } from './baseRequest';

const baseRoute = '/auth';

export const ping = (): Promise<AxiosResponse<void>> => baseRequest.post<void>(`${baseRoute}/ping`);

export const touch = (): Promise<AxiosResponse<void>> => baseRequest.post<void>(`${baseRoute}/touch`);

export const login = async (loginBody: Identity.API.LoginBody): Promise<AxiosResponse<Identity.API.AuthResponse>> =>
  baseRequest.post<Identity.API.AuthResponse>(`${baseRoute}/login`, loginBody);

export const logout = (): void => window.location.assign(getConfig().logoutUrl);

export const logoutAndSetClientApp = async (clientAppId: string): Promise<AxiosResponse<Identity.API.AuthResponse>> =>
  baseRequest.get<Identity.API.AuthResponse>(`${baseRoute}/logout?clientAppId=${clientAppId}`);

export const resendEmailMFAChallenge = (): Promise<AxiosResponse<Identity.API.AuthResponse>> =>
  baseRequest.post<Identity.API.AuthResponse>(`${baseRoute}/email-mfa/resend`);

export const respondToAuthChallenge = async (
  challengeResponse: Identity.API.ChallengeResponse,
): Promise<AxiosResponse<Identity.API.AuthResponse>> =>
  baseRequest.post<Identity.API.AuthResponse>(`${baseRoute}/challenge`, { challengeResponse });

export const resetToMFASetupChallenge = async (): Promise<AxiosResponse<Identity.API.AuthResponse>> =>
  baseRequest.post<Identity.API.AuthResponse>(`${baseRoute}/return-to-mfa-setup-challenge`);

export const forgotPassword = async (
  newPasswordBody: Identity.API.ResetPasswordBody,
): Promise<AxiosResponse<Identity.API.AuthResponse>> =>
  baseRequest.post<Identity.API.AuthResponse>(`${baseRoute}/reset-password/initiate`, newPasswordBody);

export const confirmNewPassword = async (
  confirmPasswordBody: Identity.API.ResetPasswordConfirmationBody,
): Promise<AxiosResponse<void>> => baseRequest.post<void>(`${baseRoute}/reset-password/confirm`, confirmPasswordBody);

export const getChallengeMetadata = async (): Promise<
  AxiosResponse<Identity.API.GetPrincipalsForPrincipalSelectionResponse>
> => baseRequest.post<Identity.API.GetPrincipalsForPrincipalSelectionResponse>(`${baseRoute}/challenge-metadata`);

export const baseRequestWithoutRedirect = axios.create(axiosDefaults);

export const getMe = async (): Promise<AxiosResponse<Identity.API.User>> =>
  baseRequestWithoutRedirect.get<Identity.API.User>(`${baseRoute}/me`);
